import styled from '@emotion/styled';
import { media, ButtonEmotion, helperHorizontalScrollingContainer } from '@utex/ui-kit';

export const ButtonsWrapper = styled('div')`
  ${helperHorizontalScrollingContainer};
  --button-padding-m: 0 2rem 0 1.4rem;
  margin-left: -4rem;
  margin-right: -4rem;
  padding-left: 4rem;
  padding-top: 1rem;
  padding-bottom: 1rem;

  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media ${media.phonablet} {
    margin-left: -1.6rem;
    margin-right: -1.6rem;
    padding-left: 1.6rem;
  }

  ${ButtonEmotion} {
    flex-shrink: 0;
  }
  ${ButtonEmotion} + ${ButtonEmotion} {
    margin-left: 0.5rem;
  }
`;
